import React, {Component} from 'react';
import axios from 'axios';
import { Cookies } from 'react-cookie';
import NumberFormat from 'react-number-format';
import 'react-tippy/dist/tippy.css';

class ConnectForm extends Component {
  constructor (props) {
    super(props);
    this.state = {
      url: `${process.env.REACT_APP_API_URL}/services/guide`,
      area: props.area,
      first_name: '',
      last_name: '',
      phone: '',
      company: '',
      email: '',
      group_size: '',
      person_type: '',
      formErrors: {},
      success: false,
      submitting: false
    };
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentDidMount () {
    this.checkForCampaignCookies();
  }

  checkForCampaignCookies = () => {
    return new Promise((resolve) => {
      const cookies = new Cookies();
      const MarketingCampaignSource = cookies.get('CDPHP_Marketing_Campaign_Source') || 'Not Set';
      this.setState({
        marketingSource: MarketingCampaignSource
      }, resolve);
    });
  }

  handleInputChange = (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value
    });
  }

  handleSubmit = async (event) => {
    event.preventDefault();

    await this.checkForCampaignCookies();

    let formResults;

    formResults = {
      'area': this.state.area,
      'first_name': this.state.first_name,
      'last_name': this.state.last_name,
      'company': this.state.company,
      'email': this.state.email,
      'phone': this.state.phone,
      'Group_Size_Range__c': this.state.group_size,
      'Details__c': this.state.person_type,
      'Campaign__c': this.state.marketingSource.leadCampaign,
      'Content__c': this.state.marketingSource.leadContent,
      'Medium__c': this.state.marketingSource.leadMedium,
      'Source__c': this.state.marketingSource.leadSource,
      'GCLID__c': this.state.marketingSource.leadGCLID
    };
    console.log(formResults);

    const errors = this.validateForm(formResults);
    const isDisabled = Object.keys(errors).some(x => errors[x]);
    if (!isDisabled) {
      this.setState({submitting: true});
      axios.post(
        this.state.url, formResults
      ).then(response => {
        this.setState({submitting: false});
        this.setState({success: true});
        this.resetForm();
        const copy = this.props.displayInline === true ? '' : 'Hudson Valley ';
        const formID = this.state.area === 'LargeGroupDownload' ? 'Plans - Self Funded Paper Download Lead' : 'Plans - ' + copy + 'Large Group Lead';

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'formSubmit',
          'formID': formID
        });
      }).catch(error => {
        console.log('Error Message: ' + error);
      });
    } else {
      this.setState({formErrors: errors});
    }
  }

  validateForm = (formResults) => {
    let formErrors = {};

    if (formResults.first_name.length < 2) {
      formErrors.first_name = 'Required';
    }

    if (formResults.last_name.length < 2) {
      formErrors.last_name = 'Required';
    }

    if (formResults.company.length < 2) {
      formErrors.company = 'Required';
    }

    if (!formResults.email) {
      formErrors.email = 'Required';
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(formResults.email)) {
      formErrors.email = 'Invalid email address';
    }

    if (!formResults.phone || formResults.phone.length < 10) {
      formErrors.phone = 'Required';
    } else if (!/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/.test(formResults.phone)) {
      formErrors.phone = 'Invalid phone number';
    }

    if (formResults.Group_Size_Range__c === '') {
      formErrors.group_size = 'Required';
    }

    if (formResults.Details__c === '') {
      formErrors.person_type = 'Required';
    }

    return formErrors;
  }

    closeForm = () => {
      this.resetForm();
      this.props.closeModal();
      var that = this;
      setTimeout(function () {
        that.setState({
          success: false
        });
      }, 500);
    }

    resetForm = () => {
      console.log('Reset');
      this.setState({
        formErrors: {},
        first_name: '',
        last_name: '',
        email: ''
      });
    }

    trackEnrollment = () => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'GAEvent',
        'eventCategory': 'Click',
        'eventAction': 'Load Website',
        'eventLabel': 'Go to DRx',
        'eventValue': undefined
      });
    }

    render () {
      const display = (this.props.show === true ? 'show' : (this.props.displayInline === true ? 'inline-form' : ''));
      const copy = this.props.type === 'paper' ? <p><a href={this.props.paperUrl} target='_blank' rel='noreferrer'>Download</a> your copy of <em>{this.props.paperTitle}</em></p> : <p>A sales representative will be in touch.</p>;

      let Success = null;
      if (this.state.success) {
        Success = (<div id='success' className={this.state.success ? 'show' : ''}>
          <div>
            <h4>Thanks!</h4>
            { copy }
          </div>
        </div>);
      }

      return (
        <section id='connectOverlay' className={'modal ' + display}>
          <div id='overlayBG' onClick={(this.props.displayInline === true ? null : (e) => this.closeForm(e))}>
            <div id='overlay' onClick={(event) => { event.stopPropagation(); }}>
              <div className='wrap sm'>
                <div className={(this.state.submitting ? ' loading' : '')}>
                  <button className='close' onClick={(e) => this.closeForm(e)}>Close</button>
                  <div className={this.state.submitting ? ' loading' : ''}>
                    <div className='form-content'>
                      <h3>{this.props.heading ? this.props.heading : 'Connect with Us'}</h3>
                      {this.props.subheading !== false ? <p>Please complete the form below to get started.</p> : null}
                      <form onSubmit={this.handleSubmit}>
                        <div className='two-col'>
                          <p>
                            <label>First Name</label>
                            <input
                              name='first_name'
                              id='first_name'
                              type='text'
                              className={'first_name ' + (this.state.formErrors.first_name ? 'error' : '')}
                              value={this.state.first_name}
                              onChange={this.handleInputChange} />
                          </p>
                          <p>
                            <label>Last Name</label>
                            <input
                              name='last_name'
                              id='last_name'
                              type='text'
                              className={'last_name ' + (this.state.formErrors.last_name ? 'error' : '')}
                              value={this.state.last_name}
                              onChange={this.handleInputChange} />
                          </p>
                        </div>
                        <p>
                          <label>Company</label>
                          <input
                            name='company'
                            id='company'
                            type='text'
                            className={'company ' + (this.state.formErrors.company ? 'error' : '')}
                            value={this.state.company}
                            onChange={this.handleInputChange} />
                        </p>
                        <p>
                          <label>Email</label>
                          <input
                            name='email'
                            id='email'
                            type='text'
                            className={'email ' + (this.state.formErrors.email ? 'error' : '')}
                            placeholder='you@here.com'
                            value={this.state.email}
                            onChange={this.handleInputChange} />
                        </p>
                        <p>
                          <label>Phone</label>
                          <NumberFormat
                            format='(###) ###-####'
                            mask='_'
                            name='phone'
                            id='phone'
                            type='tel'
                            placeholder='(XXX) XXX-XXXX'
                            className={'phone ' + (this.state.formErrors.phone ? 'error' : '')}
                            value={this.state.phone}
                            onChange={this.handleInputChange}
                          />
                        </p>
                        <p>
                          <label>Organization Size</label>
                          <select
                            name='group_size'
                            id='group_size'
                            className={(this.state.formErrors.group_size ? 'error' : '')}
                            value={this.state.group_size}
                            onChange={this.handleInputChange}>
                            <option value=''>Select size</option>
                            <option value='1-25'>1-25</option>
                            <option value='26-50'>26-50</option>
                            <option value='51-100'>51-100</option>
                            <option value='101+'>101+</option>
                            <option value='250+'>250+</option>
                            <option value='500+'>500+</option>
                            <option value='750+'>750+</option>
                            <option value='1000+'>1000+</option>
                          </select>
                        </p>
                        <p>
                          <label>I&rsquo;m a</label>
                          <select
                            name='person_type'
                            id='person_type'
                            className={(this.state.formErrors.person_type ? 'error' : '')}
                            value={this.state.person_type}
                            onChange={this.handleInputChange}>
                            <option value=''>Select one</option>
                            <option value='broker'>Broker</option>
                            <option value='employer'>Employer</option>
                            <option value='current-cdphp-client'>Current CDPHP Client</option>
                          </select>
                        </p>
                        <em className='desc'>By providing this information, you give a CDPHP sales representative permission to contact you.</em>

                        <p className='submitForm'>
                          <input type='submit' value={this.props.submitText ? this.props.submitText : 'Submit'} className='btn' />
                        </p>
                      </form>
                    </div>
                    {Success}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      );
    }
}

export default ConnectForm;



// WEBPACK FOOTER //
// ./src/components/Forms/Connect.js